export default __webpack_public_path__ + "static/media/ThinkPartners.f3a0311c7b7dcbcb2f50caaee8435392.webp";